// 实现来源： https://github.com/artem0/canvas-fingerprinting?tab=readme-ov-file

function getScreenResolution() {
  return screen.height > screen.width ? [screen.height, screen.width] : [screen.width, screen.height];
}

function isCanvasSupported() {
  if (typeof document !== 'undefined') {
    try {
      const elem = document.createElement('canvas');
      return !!(elem.getContext && elem.getContext('2d'));
    } catch (error) {
      return false;
    }
  }
  return false;
}

function createCanvasFingerprinting() {
  if (typeof document !== 'undefined') {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    if (!ctx) {
      return '';
    } else {
      // Text with lowercase/uppercase/punctuation symbols
      const txt = 'HopeGoo,com <canvas> 0.1';
      ctx.textBaseline = 'bottom';
      // The most common type
      ctx.font = "14px 'Arial'";
      ctx.textBaseline = 'alphabetic';
      ctx.fillStyle = '#f20';
      ctx.fillRect(139, 1, 62, 20);
      // Some tricks for color mixing to increase the difference in rendering
      ctx.fillStyle = '#069';
      ctx.fillText(txt, 2, 15);
      ctx.fillStyle = 'rgba(102, 203, 0, 0.7)';
      ctx.fillText(txt, 4, 17);
      return canvas.toDataURL();
    }
  }
  return '';
}

function javaHashCode(string: string, K: number) {
  let char;
  let hash = 16;
  if (string.length === 0) {
    return hash;
  }
  for (let i = 0; i < string.length; i++) {
    char = string.charCodeAt(i);
    hash = K * ((hash << 5) - hash) + char;
    hash = hash & hash;
  }
  return Math.abs(hash).toString(16);
}
/** 生成设备指纹（简易版本） */
export function createFingerprint() {
  if (typeof window === 'undefined') return '';
  const keys: string[] = [];
  keys.push(navigator.userAgent);
  keys.push(navigator.language);
  keys.push('' + screen.colorDepth);
  keys.push(getScreenResolution().join('x'));
  keys.push('' + new Date().getTimezoneOffset());
  keys.push(navigator.platform);
  if (isCanvasSupported()) {
    keys.push(createCanvasFingerprinting());
  }
  return javaHashCode(keys.join('###'), 31);
}
